const APIHOST = "https://admin.gaoyangnyfwpt.com/api";
const TOKEN = "6595880e8c2f7425bdfeced2704cdc92";
const WSSURL = "wss://admin.gaoyangnyfwpt.com:9453"

var BASEURL = {
	uploadFile: '/index/upload-file', //上传文件
	indexBan: '/index/get-banner',
	baseInfo: '/index/bottom-common', //公共信息
	danyeInfo: '/index/get-danye', //关于我们
	rzdwList: '/index/get-danwei', //入驻单位
	dzbhzsList: '/index/get-hezuoshe', //党支部合作社列表
	dzbhzsDetail: '/index/get-hezuoshedetail', //党支部合作社详情
	dzbhzsClaList: '/index/get-hezuosheclass', //
	dsnyClaList: '/index/get-nongyeclass', //现代都市农业分类
	dsnyList: '/index/get-nongye', //现代都市农业列表
	dsnyDetail: '/index/get-nongyedetail', //现代都市农业详情
	dsnyDetailBd: '/index/add-nongyehezuo', //都市农业  提交合作
	nyzcList: "/index/get-zhengce", //农业政策列表
	nyzcDetail: "/index/get-zhengcedetail", //农业政策详情
	nyzcClaList: '/index/get-zhengceclass', //农业政策分类
	zsfwList: "/index/get-zhaoshang", //招商服务列表
	zsfwDetail: "/index/get-zhaoshangdetail", //招商服务详情
	zsfwClaList: '/index/get-zhaoshangclass', //招商服务分类
	zsfwSave: '/index/add-zhaoshanghezuo', //招商服务
	checkToken: '/index/yanzheng-token', //验证登录状态

	rcfwClaList: '/index/get-rencaiclass', //人才服务分类
	rcfwDetail: '/index/get-rencaidetail', //人才服务详情
	rcfwList: '/index/get-rencai', //人才服务列表
	rcfwBdAdd: '/index/add-rencaiwenda', //人才服务我要咨询
	rcfwZwList: "/index/get-rencaizuowu", //人才服务作物列表


	jinrongQixian: '/index/get-jinrongqixian', //金融期限
	jinrongDanbao: '/index/get-jinrongdanbao', //金融担保
	jinrongJigou: '/index/get-jinrongjigou', //金融机构
	jinrongLeixing: '/index/get-jinrongleixing', //金融类型
	jinrongEdu: '/index/get-jinrongedu', //金融额度
	jinrongClass: '/index/get-jinrongclass', //金融分类
	jinrongList: '/index/get-jinrong', //金融列表
	jinrongDetail: '/index/get-jinrongdetail', //金融详情
	jinrongAdd: '/index/add-jinrong',
	jinrongShenqing: '/index/get-jinrongshenqing',

	getYzm: '/index/get-yanzhenma2', //获取验证码
	getSmsCode: '/user/get-sms-code', //获取短信验证码
	getSmsCode3: '/user/get-sms-code3', //获取短信验证码
	getSmsCheck: '/user/check-sms-code', //验证验证码是否正确
	loginReg: '/login/zhuce', //注册
	loginPwd: "/login/pwd", //密码登录
	loginSms: '/user/sms-login', //验证码登录
	loginWxCode: '/index/get-saoma', //微信扫码登录  获取二维码
	loginWxSta: '/index/saoma3', //获取微信扫码状态

	myInfo: '/user/get-userinfo', //我的信息
	myRenzheng: '/index/renzheng', //认证
	myRenzhengInfo: '/index/get-renzheng', //获取认证信息
	myNotice: '/user/get-news', //消息通知
	myNoticeDetail: '/user/get-newsdetail', //消息通知
	myNoticeZx: '/index/get-wenda2', //咨询回复
	myZjNotice: '/index/get-rencaitiwen2', //我提交的专家咨询
	myJingjiaBm: "/index/get-baoming", //竞价项目
	myJingjiaHis: '/index/get-chujia2', //历史竞价
	myJingjiaWin: '/index/get-zhongbiao', //我中标的
	myJingjiaOk: '/user/queren-order', //确认完成
	myJingjiaZbSta: '/index/add-fuwuzhongbiao', //中标签署合同
	myNums: '/user/get-userinfo2', //我的里面的数据
	myJinrong: '/index/get-jinrongshenqing', //我申请的贷款
	myFabuSave: '/index/fabu-fuwu', //我要发布
	myFabuList: '/index/get-fuwu2', //我的发布列表
	myUpdatePwd: '/user/update-password', //修改密码
	mySetPwd: '/user/update-password2', //重置密码
	myZhuxiao: '/index/zhuxiao', //注销
	myBankEdit: '/user/edit-userinfo', //绑定银行账号
	myInfoEdit: '/user/edit-userinfo', //修改信息
	myWxbdSave: '/user/edit-userinfo', //绑定微信
	myEmailEdit: '/user/edit-youxiang', //修改邮箱
	myEmailCode: '/user/fasong-youxiang', //发送验证码

	myBankType: '/user/banklist', //银行卡类型
	mySaveBank: '/user/addbank', //保存银行卡
	myBankInfo: '/user/banklist2', //保存银行卡


	myAdList: '/address/get-address-list', //收货地址
	myAdAdd: '/address/create-address-info',
	myAdDel: '/address/del-address-info',
	myAdEdit: '/address/update-address-info',
	myAdSetDef: '/address/set-default-address',
	myOrderInfo: '/user/get-User-order-details', //订单详情
	placeOrder: '/product/place-order', //下单
	myOrderList: '/user/get-User-order', //订单列表
	myLeftInfo: '/user/get-userinfo3', //
	myProAdd: '/index/add-product', //添加商品
	myProDel: '/index/del-product', //删除
	myProList: '/product/product-list',
	myProClass: '/product/product-class',
	myProNums: '/index/get-productcishu', //获取是否有发布条数
	myOrderOk: '/user/cancel-order', //确认收货
	myProEdit: '/index/add-product2', //编辑商品某个字段



	indexNews: "/index/get-wuyezixun", //首页新闻资讯
	indexNewsHdp: "/index/get-wuyezixun2", //首页新闻资讯
	indexNewsCla: '/index/get-wuyezixunclass', //新闻资讯分类
	indexNewsDetail: '/index/get-wuyezixundetail', //新闻详情
	indexGongshi: '/index/get-gongshi', //农业公示
	indexGongshiDetail: '/index/get-gongshidetail', //公示详情
	indexLink: '/index/get-youqing', //友情链接列表
	indexWenda: '/index/get-wenda', //专家问答

	nyfwPhb: '/index/get-paihang', //排行榜
	myfwClaList: '/index/get-fuwuclass', //农业服务分类
	myfwList: '/index/get-fuwu', //农业服务列表
	myfwQuyu: '/index/get-fuwuquyu', //农业服务区域
	myfwAdd: '/index/fabu-fuwu', //添加服务
	nyfwDetail: '/index/get-fuwudetail2', //农业服务详情

	jingjiaBmCheck: '/index/add-baoming2', //竞价报名验证
	jingjiaBmSave: '/index/add-baoming', //竞价报名
	jingjiaBmInfo: '/index/get-baomingdetail', //竞价报名信息
	jingjiaMyList: '/index/get-chujia', //我出价的列表
	jingjiaList: '/index/get-fwuuchujia', //项目出价的列表
	jingjiaMyCj: '/index/get-fuwuchujianum', //竞价 我的出价

	wyzxAdd: "/index/add-wenda", //我要咨询
	wyzxList: "/index/get-wenda", //我要咨询列表

	proClassList: '/product/product-class', //电商服务  分类
	proList: '/product/product-list', //1产品 2直播 3农业产品
	proDetail: '/product/product-detail', //电商服务详情

	//专家 回答列表
	zjZixunList: '/index/get-rencaitiwen',
	zjZixunHuifu: '/index/add-rencaitiwen',

	toPay: '/pay/pay', //支付
	toPayStatus: '/index/get-paystatus', //查询支付状态

	indexDanye: '/index/get-danye2', //关于我们

	productAdd: '/index/add-product',
	productList: '/product/product-list',
	productDel: '/index/del-product',

	myNoticeZx2: '/index/get-wenda3', //咨询回复
	myNoticeZxRead: '/index/see-wenda', //公共咨询设置成已读

	userOrderTui: '/user/cancel-order', //用户订单退款
	userOrderYy: '/user/get-tuikuanreason', //退款原因
	userOrderDel: '/user/del-order', //用户删除订单
	sjOrderList: '/user/get-shangorder', //商家订单列表
	sjOrderEdit: '/user/add-shangorder', //商家订单列表
	sjWuliu: '/user/get-wuliugongsi',
	sjOrderFa: '/user/add-wuliudanhao', //发货
	sjJpOrderFa: '/user/add-wuliudanhao2', //竞拍发货


	nyaiApi: '/index/getai', //农业ai

};

const config = {
	APIHOST: APIHOST,
	TOKEN: TOKEN,
	BASEURL: BASEURL,
	WSSURL: WSSURL
};

export default config;